<template>
  <div class="dp_flex">
    <sui-select-box
      ref="level1"
      v-model="currentSelected.level1"
      :option-list="currentOptions.level1"
      :disabled="level1Disabled"
      @list-click="level1ListClick"
    />
    <div class="comp_spacing" />
    <sui-select-box
      ref="level2"
      v-model="currentSelected.level2"
      :option-list="currentOptions.level2"
      :disabled="level2Disabled"
      @list-click="level2ListClick"
    />
    <div class="comp_spacing" />
    <sui-select-box
      ref="level3"
      v-model="currentSelected.level3"
      :option-list="currentOptions.level3"
      :disabled="level3Disabled"
      @list-click="level3ListClick"
    />
    <div class="comp_spacing" />
    <sui-select-box
      ref="level4"
      v-model="currentSelected.level4"
      :option-list="currentOptions.level4"
      :disabled="level4Disabled"
      @list-click="level4ListClick"
    />
  </div>
</template>

<script>
import selectUtil from '../../../../common/js/select-util';

export default {
  name: 'CmpVendorCategorySelect',
  props: {
    // 이 컴포넌트를 사용하는 페이지ID, 데이터서비스 호출시 사용
    pageId: {
      type: String,
      required: true,
    },
    selected: {
      type: Object,
      required: true,
    },
    defaultOption: {
      type: String,
      required: false,
      default: '',
    },
    initial1LevelIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    initial2LevelIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    initial3LevelIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    initial4LevelIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    initial1LevelValue: {
      type: String,
      required: false,
      default: '',
    },
    initial2LevelValue: {
      type: String,
      required: false,
      default: '',
    },
    initial3LevelValue: {
      type: String,
      required: false,
      default: '',
    },
    initial4LevelValue: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledLevel1: {
      type: Boolean,
      default: false,
    },
    disabledLevel2: {
      type: Boolean,
      default: false,
    },
    disabledLevel3: {
      type: Boolean,
      default: false,
    },
    disabledLevel4: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        level1: {},
        level2: {},
        level3: {},
        level4: {},
      },
      currentOptions: {
        level1: [],
        level2: [],
        level3: [],
        level4: [],
      },
      currentSelected: {
        level1: {
          key: '',
          label: '',
        },
        level2: {
          key: '',
          label: '',
        },
        level3: {
          key: '',
          label: '',
        },
        level4: {
          key: '',
          label: '',
        },
        companyCategoryId: '',
        companyCategoryLevel: 0,
      },
    };
  },
  computed: {
    level1Disabled() {
      return this.disabled || this.disabledLevel1 || this.disabledLevel2 || this.disabledLevel3 || this.disabledLevel4;
    },
    level2Disabled() {
      return this.disabled || this.disabledLevel2 || this.disabledLevel3 || this.disabledLevel4;
    },
    level3Disabled() {
      return this.disabled || this.disabledLevel3 || this.disabledLevel4;
    },
    level4Disabled() {
      return this.disabled || this.disabledLevel4;
    },
    initialLevel1key() {
      return this.initial1LevelValue || this.initial1LevelIndex;
    },
    initialLevel2key() {
      return this.initial2LevelValue || this.initial2LevelIndex;
    },
    initialLevel3key() {
      return this.initial3LevelValue || this.initial3LevelIndex;
    },
    initialLevel4key() {
      return this.initial4LevelValue || this.initial4LevelIndex;
    },
    defaultKey() {
      if (!utils.isEmpty(this.defaultOption)) {
        return utils.isEqual(this.defaultOption, 'all') ? 'ALL' : ' ';
      }
      return '';
    },
    defaultList() {
      return selectUtil.mergeDefaultOption([], this.defaultOption);
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this._load();
    });
  },
  beforeDestroy() {
  },
  methods: {
    _load() {
      this.categoryListLoad('0', 1).then(list => {
        this.options.level1 = list;
        this.currentOptions.level1 = this.options.level1;
        this._loaded();
      });
    },
    _loaded() {
      const load = true;
      const level1 = this.currentSelected.level1.key || this.initialLevel1key;
      const level2 = this.currentSelected.level2.key || this.initialLevel2key;
      const level3 = this.currentSelected.level3.key || this.initialLevel3key;
      const level4 = this.currentSelected.level4.key || this.initialLevel4key;

      this.selectAll(level1, level2, level3, level4, load);
    },
    categoryListLoad(parentsId) {
      return new Promise((resolve, reject) => {
        if (utils.isEqual(parentsId, this.defaultKey)) {
          reject();
        } else {
          http.request(this.pageId, 'DTS_CMY_00025', {
            path: {
              'parents-category-id': parentsId,
            },
          }).then(res => {
            const options = [];
            utils.forEach(res.data, data => {
              options.push({
                key: data.companyCategoryId,
                label: data.companyCategoryName,
              });
            });
            resolve(selectUtil.mergeDefaultOption(options, this.defaultOption));
          }).catch(error => {
            console.log(error);
          });
        }
      });
    },
    selectAll(level1, level2, level3, level4, load = false) {
      this._selectLevel(level1, 1).then(() => {
        this._selectLevel(level2, 2).then(() => {
          this._selectLevel(level3, 3).then(() => {
            this.selectLevel4(level4);

            if (load) {
              this.$emit('loaded');
            }
          });
        });
      });
    },
    level1ListClick(event) {
      const { key } = event;
      if (!utils.isEqual(this.selected.level1.key, key)) {
        this._selectLevel(key, 1).then(() => {
          this.selectLevel2(0);

          this.$emit('level1-list-clicked', event);
        });
      }
    },
    level2ListClick(event) {
      const { key } = event;
      if (!utils.isEqual(this.selected.level2.key, key)) {
        this._selectLevel(key, 2).then(() => {
          this.selectLevel3(0);

          this.$emit('level2-list-clicked', event);
        });
      }
    },
    level3ListClick(event) {
      const { key } = event;
      if (!utils.isEqual(this.selected.level3.key, key)) {
        this._selectLevel(key, 3).then(() => {
          this.selectLevel4(0);

          this.$emit('level3-list-clicked', event);
        });
      }
    },
    level4ListClick(event) {
      const { key } = event;
      if (!utils.isEqual(this.selected.level4.key, key)) {
        this.selectLevel4(key);

        this.$emit('level4-list-clicked', event);
      }
    },
    selectLevel1(key) {
      this._selectLevel(key, 1).then(() => {
        this.selectLevel2(0);
      });
    },
    selectLevel2(key) {
      this._selectLevel(key, 2).then(() => {
        this.selectLevel3(0);
      });
    },
    selectLevel3(key) {
      this._selectLevel(key, 3).then(() => {
        this.selectLevel4(0);
      });
    },
    selectLevel4(key, load = false) {
      const realkey = typeof key === 'string' ? key : this.currentOptions.level4[key].key;
      if (utils.isEqual(this.currentOptions.level4, this.options.level4[this.currentSelected.level3.key])) {
        const target = utils.find(this.currentOptions.level4, { key: realkey });
        this.currentSelected.level4 = target;

        this.$emit('level4-selected', target);
        if (!load) {
          this._syncProps();
        }
      }
    },
    _selectLevel(key, level) {
      return new Promise(resolve => {
        const self = this;
        const preLevels = `level${level - 1}`;
        const levels = `level${level}`;
        const nextLevels = `level${level + 1}`;
        const event = `${levels}-selected`;

        const realkey = typeof key === 'string' ? key : self.currentOptions[levels][key].key;
        const parentskey = level !== 1 ? self.currentSelected[preLevels].key : '';

        if (level === 1 || utils.isEqual(self.currentOptions[levels], self.options[levels][parentskey])) {
          const target = utils.find(self.currentOptions[levels], { key: realkey });
          self.currentSelected[levels] = target;

          self.$emit(event, target);

          if (!utils.has(self.options[nextLevels], realkey)) {
            self.categoryListLoad(realkey).then(list => {
              utils.set(self.options[nextLevels], realkey, list);
              self.currentOptions[nextLevels] = utils.cloneDeep(self.options[nextLevels][realkey]);
              resolve();
            }).catch(() => {
              utils.set(self.options[nextLevels], self.defaultKey, self.defaultList);
              self.currentOptions[nextLevels] = utils.cloneDeep(self.options[nextLevels][realkey]);
              resolve();
            });
          } else {
            self.currentOptions[nextLevels] = utils.cloneDeep(self.options[nextLevels][realkey]);
            resolve();
          }
        }
      });
    },
    _syncProps() {
      const selected = {
        level: 0,
        key: '',
      };
      if (!utils.isEqual(this.currentSelected.level1.key, this.selected.level1.key)) {
        this.selected.level1.key = this.currentSelected.level1.key;
        this.selected.level1.label = this.currentSelected.level1.label;
        if (!utils.isEqual(this.currentSelected.level1.key, this.defaultKey)) {
          selected.level = 1;
          selected.key = this.currentSelected.level1.key;
        }
      }
      if (!utils.isEqual(this.currentSelected.level2.key, this.selected.level2.key)) {
        this.selected.level2.key = this.currentSelected.level2.key;
        this.selected.level2.label = this.currentSelected.level2.label;
        if (!utils.isEqual(this.currentSelected.level2.key, this.defaultKey)) {
          selected.level = 2;
          selected.key = this.currentSelected.level2.key;
        }
      }
      if (!utils.isEqual(this.currentSelected.level3.key, this.selected.level3.key)) {
        this.selected.level3.key = this.currentSelected.level3.key;
        this.selected.level3.label = this.currentSelected.level3.label;
        if (!utils.isEqual(this.currentSelected.level3.key, this.defaultKey)) {
          selected.level = 3;
          selected.key = this.currentSelected.level3.key;
        }
      }
      if (!utils.isEqual(this.currentSelected.level4.key, this.selected.level4.key)) {
        this.selected.level4.key = this.currentSelected.level4.key;
        this.selected.level4.label = this.currentSelected.level4.label;
        if (!utils.isEqual(this.currentSelected.level4.key, this.defaultKey)) {
          selected.level = 4;
          selected.key = this.currentSelected.level4.key;
        }
      }
      this.selected.companyCategoryId = selected.key;
      this.selected.companyCategoryLevel = selected.level;
    },
    reset() {
      this.selectLevel1(this.initialLevel1key);
    },
    setFocus(level) {
      const levels = `level${level}`;
      if (this.$refs[levels]) {
        this.$refs[levels].activate();
      }
    },
  },
};
</script>

<style scoped>
</style>
